module.exports = __webpack_public_path__ + "img/logoseif.35617e00.svg";